
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contest-lobby",
      function () {
        return require("private-next-pages/contest-lobby.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contest-lobby"])
      });
    }
  